<template>
  <footer :style="$theme.bottomStyle">
    <div class="title">
      <span class="dot size-1" />
      <span class="dot size-2" />
      <span class="dot size-3" />
      <h3>学生认证须知</h3>
      <span class="dot size-3" />
      <span class="dot size-2" />
      <span class="dot size-1" />
    </div>
    <p>* 填写姓名身份证号和学生信息即可完成认证;</p>
    <p>* 权益详情以美团民宿学生特权卡活动规则为准。</p>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
footer {
  text-align: center;
  padding: 10px 0;
  font-size: 11px;
  line-height: 1.8;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 100px;
    .dot {
      border-radius: 100%;
      height: 0;
      background-color: transparent;
      each(range(3), {
        &.size-@{value} {
          border: @value * 2px solid rgba(255, 255, 255, 0.4);
        }
      });
    }
  }
  h3 {
    a {
      font-size: 12px;
      color: inherit;
    }
  }
}
</style>
